import { useEffect, useRef } from "react";

export default function FilterListSection({
  filterOptions,
  setSelectedFilterCategory,
  selectedCategory,
}: any) {
  // Filter out "country" key if it's "study-in-india"
  const filtersToShow =
    filterOptions?.country?.country_url === "study-in-india"
      ? Object.entries(filterOptions).filter(([key]) => key !== "country")
      : Object.entries(filterOptions);

  // Only show specialization if both stream and course are selected
  // const shouldShowSpecialization =
  //   filterOptions?.stream && filterOptions?.course;

  const availableFilters = [
    "country",
    "state",
    "city",
    "stream",
    "course",
    // ...(shouldShowSpecialization ? ["specialization"] : []),
  ];

  const mobileFilter = ["country", "state", "city", "stream", "course"];

  // Only set default on first mount
  const didSetDefault = useRef(false);
  useEffect(() => {
    // Only set default if selectedCategory is undefined (never set), not null (closed)
    if (typeof selectedCategory === "undefined" && filtersToShow.length > 0 && !didSetDefault.current) {
      setSelectedFilterCategory(filtersToShow[0][0]);
      didSetDefault.current = true;
    }
  }, [selectedCategory, filtersToShow, setSelectedFilterCategory]);

  return (
    <div>
      {/* desktop view: */}
      <div className="hidden lg:flex gap-x-3 overflow-x-auto">
        {filtersToShow
          .filter(([key]) => availableFilters.includes(key))
          .map(([key, value]) => (
            <button
              key={key}
              onClick={() => setSelectedFilterCategory(key)}
              className={`px-4 py-0.5 text-gray-600 border border-gray-300 min-w-16 rounded-full capitalize text-sm font-light font-inter transition duration-200 ${
                value
                  ? "bg-primary text-white font-normal hover:bg-primary hover:text-white"
                  : null
              } ${
                selectedCategory === key
                  ? "bg-primary text-white relative"
                  : "hover:bg-gray-50 hover:text-black"
              }`}
            >
              {key}
            </button>
          ))}
      </div>
      {/* mobile view: */}
      <div className="lg:hidden">
        {filtersToShow
          .filter(([key]) => mobileFilter.includes(key))
          .map(([key, value]) => (
            <button
              key={key}
              onClick={() => setSelectedFilterCategory(key)}
              className={`block w-full text-left p-2 mb-2 ${
                selectedCategory === key
                  ? "border-l-2 border-[#334988] text-[#334988] font-semibold"
                  : "text-gray-700"
              }${value ? " text-primary font-bold" : null}
      `}
            >
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </button>
          ))}
      </div>
    </div>
  );
}
